<template>
  <Container tagName="section" class="LogoGridModule">
    <h2 v-if="content.heading" class="heading">{{ content.heading }}</h2>
    <LogoGrid :logos="content.logos" class="logoGrid" />
  </Container>
</template>

<script>
import LogoGrid from '../elems/LogoGrid.vue'

export default {
  components: {
    LogoGrid,
  },
  props: {
    content: Object,
  },
}
</script>

<style scoped>
.LogoGridModule {
  background-color: var(--bg-color-pale-blue);
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
}
.heading {
  font-weight: 600;
  font-size: var(--font-size-8);
  line-height: 1.3;
  color: var(--text-color-black);
  text-align: center;
}
.logoGrid {
  max-width: 65rem;
  margin-left: auto;
  margin-right: auto;
}
.heading + .logoGrid {
  margin-top: var(--spacing-12);
}
.logoGrid + .ctaWrapper {
  margin-top: var(--spacing-8);
}
</style>
